'use strict';

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Col = require('react-bootstrap/lib/Col');

var _Col2 = _interopRequireDefault(_Col);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _mozart_ui = require('@pgforsta/mozart_ui');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SurveyFooter = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(SurveyFooter, _Component);

  function SurveyFooter(props) {
    (0, _classCallCheck3.default)(this, SurveyFooter);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.styles = require('./SurveyFooter.scss');
    _this.state = {
      isHovering: false,
      current_move: 'forward',
      height: window.innerHeight || document.documentElement.clientHeight,
      width: window.innerWidth || document.documentElement.clientWidth,
      device_type: (window.innerWidth || document.documentElement.clientWidth) < 992 ? 'mobile' : 'desktop'
    };
    return _this;
  }

  SurveyFooter.prototype.componentDidMount = function componentDidMount() {
    //     console.log(this.props.survey);
  };

  SurveyFooter.prototype.onBackClick = function onBackClick() {
    if (this.props.onBackClick) {
      this.props.onBackClick();
    }
  };

  SurveyFooter.prototype.onNextClick = function onNextClick() {
    if (this.props.onNextClick) {
      this.props.onNextClick();
    }
  };

  SurveyFooter.prototype.getBackButton = function getBackButton() {
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_mozart_ui.MozartButton, {
        style: { border: '1px solid ' + this.props.theme.colorCode },
        data: 'Back',
        onClick: this.onBackClick.bind(this)
      })
    );
  };

  SurveyFooter.prototype.getFooterLabel = function getFooterLabel() {
    return _react2.default.createElement(
      'div',
      { className: this.styles.page_number },
      _react2.default.createElement(
        'span',
        null,
        this.props.label
      )
    );
  };

  SurveyFooter.prototype.getNextButton = function getNextButton() {
    var nextButton = '';
    nextButton = _react2.default.createElement(_mozart_ui.MozartButton, {
      style: { border: '1px solid ' + this.props.theme.colorCode },
      color: this.props.theme && this.props.theme.customTextColor ? this.props.theme.customTextColor : '#fff',
      background: this.props.theme && this.props.theme.colorCode ? this.props.theme.colorCode : true,
      data: 'Next',
      onClick: this.onNextClick.bind(this),
      disabled: !this.props.showNext
    });
    return nextButton;
  };

  SurveyFooter.prototype.render = function render() {
    var _this2 = this;

    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: this.styles.survey_footer_container },
        _react2.default.createElement(
          _Row2.default,
          { className: this.styles.survey_questions_footer },
          _react2.default.createElement(
            _Col2.default,
            { xs: 4, sm: 6, md: 6, className: this.styles.footer_button_container + ' ' + this.styles.footer_button_container_left },
            _react2.default.createElement(
              'div',
              { className: this.styles.back_button_container },
              this.props.showBack && this.getBackButton()
            )
          ),
          _react2.default.createElement(
            _Col2.default,
            { xs: 4, smHidden: true, mdHidden: true, lgHidden: true, className: this.styles.search_mobile_container, 'data-qa-type': 'search_mobile_container' },
            _react2.default.createElement(
              'div',
              { className: this.styles.mobile_search_round_button, style: { backgroundColor: this.props.theme && this.props.theme.colorCode ? this.props.theme.colorCode : '#403788' } },
              _react2.default.createElement('span', { style: { cursor: 'pointer', color: this.props.theme && this.props.theme.customTextColor ? this.props.theme.customTextColor : '#fff' }, className: 'icon-Search', onClick: function onClick() {
                  if (_this2.props.onSearchClick) {
                    _this2.props.onSearchClick();
                  }
                } })
            )
          ),
          _react2.default.createElement(
            _Col2.default,
            { xs: 4, sm: 6, md: 6, className: this.styles.footer_button_container + ' ' + this.styles.footer_button_container_right },
            _react2.default.createElement(
              'div',
              { className: this.styles.next_button_container },
              this.getNextButton()
            )
          )
        )
      )
    );
  };

  return SurveyFooter;
}(_react.Component), _class.propTypes = {
  onNextClick: _react.PropTypes.func,
  onBackClick: _react.PropTypes.func,
  onSearchClick: _react.PropTypes.func,

  showBack: _react.PropTypes.bool,
  showNext: _react.PropTypes.bool,
  showLabel: _react.PropTypes.bool,

  label: _react.PropTypes.string,

  theme: _react.PropTypes.object
}, _class.defaultProps = {
  showBack: true,
  showNext: true,
  showLabel: false
}, _temp);
exports.default = SurveyFooter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SurveyFooter/SurveyFooter.js
// module id = 2328
// module chunks = 0